<template>
    <div class="form-group input-password" :class="computedClasses">
        <div
            v-if="!strengthMeterOnly"
            class="input-password__container"
            :class="invalidClasses"
        >
            <slot
                name="password-input"
                :strength="passwordStrength"
                :type="type"
                :value="password"
            >
                <input
                    ref="input"
                    :type="type"
                    :class="[
                        inputClasses,
                        invalidClasses,
                        'form-control',
                        'input-password__input',
                        { 'input-password__input--has-toggle': showToggle }
                    ]"
                    data-toggle="tooltip-city"
                    :title="title"
                    :name="name"
                    :id="id"
                    :placeholder="placeholder"
                    :value="password"

                    :readonly="readonly"
                    :disabled="disabled"
                    :autocomplete="autocomplete"
                    :required="required"
                    :minlength="secureLength"

                    @focus="evt => handleFocus('focus', evt.target.value, true, evt)"
                    @blur="evt => handleFocus('blur', evt.target.value, false, evt)"
                    @input="evt => emitValue('input', evt.target.value, evt)"
                    @keydown.down="onKeyDown"
                    @keydown.up="onKeyUp"
                    @keydown.enter="onKeyEnter"
                    @keydown.tab="onKeyEnter"
                >
                <label class="material-label" :class="{...activeClass, ...labelClass}" :for="id">
                    <slot></slot>
                </label>
            </slot>

            <slot
                v-if="showToggle"
                name="password-toggle"
                :toggle="togglePassword"
            >
                <button
                    type="button"
                    class="input-password__toggle"
                    :aria-label="toggleMessage"
                    tabindex="-1"
                    @click.prevent="togglePassword"
                >
                    <slot name="password-hide" v-if="type === 'text'">
                        <!-- <svg
                            class="input-password__toggle-icon input-password__toggle-icon--hide"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20">
                            <path
                                d="M12.81 4.36l-1.77 1.78a4 4 0 0 0-4.9 4.9l-2.76 2.75C2.06 12.79.96 11.49.2 10a11 11 0 0 1 12.6-5.64zm3.8 1.85c1.33 1 2.43 2.3 3.2 3.79a11 11 0 0 1-12.62 5.64l1.77-1.78a4 4 0 0 0 4.9-4.9l2.76-2.75zm-.25-3.99l1.42 1.42L3.64 17.78l-1.42-1.42L16.36 2.22z"
                            />
                        </svg> -->
                        <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="input-password__toggle-icon input-password__toggle-icon--hide" aria-hidden="true" data-pc-section="unmaskicon">
                            <title> {{ toggleMessage }} </title>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0535499 7.25213C0.208567 7.59162 2.40413 12.4 7 12.4C11.5959 12.4 13.7914 7.59162 13.9465 7.25213C13.9487 7.2471 13.9506 7.24304 13.952 7.24001C13.9837 7.16396 14 7.08239 14 7.00001C14 6.91762 13.9837 6.83605 13.952 6.76001C13.9506 6.75697 13.9487 6.75292 13.9465 6.74788C13.7914 6.4084 11.5959 1.60001 7 1.60001C2.40413 1.60001 0.208567 6.40839 0.0535499 6.74788C0.0512519 6.75292 0.0494023 6.75697 0.048 6.76001C0.0163137 6.83605 0 6.91762 0 7.00001C0 7.08239 0.0163137 7.16396 0.048 7.24001C0.0494023 7.24304 0.0512519 7.2471 0.0535499 7.25213ZM7 11.2C3.664 11.2 1.736 7.92001 1.264 7.00001C1.736 6.08001 3.664 2.80001 7 2.80001C10.336 2.80001 12.264 6.08001 12.736 7.00001C12.264 7.92001 10.336 11.2 7 11.2ZM5.55551 9.16182C5.98308 9.44751 6.48576 9.6 7 9.6C7.68891 9.59789 8.349 9.32328 8.83614 8.83614C9.32328 8.349 9.59789 7.68891 9.59999 7C9.59999 6.48576 9.44751 5.98308 9.16182 5.55551C8.87612 5.12794 8.47006 4.7947 7.99497 4.59791C7.51988 4.40112 6.99711 4.34963 6.49276 4.44995C5.98841 4.55027 5.52513 4.7979 5.16152 5.16152C4.7979 5.52513 4.55027 5.98841 4.44995 6.49276C4.34963 6.99711 4.40112 7.51988 4.59791 7.99497C4.7947 8.47006 5.12794 8.87612 5.55551 9.16182ZM6.2222 5.83594C6.45243 5.6821 6.7231 5.6 7 5.6C7.37065 5.6021 7.72553 5.75027 7.98762 6.01237C8.24972 6.27446 8.39789 6.62934 8.4 7C8.4 7.27689 8.31789 7.54756 8.16405 7.77779C8.01022 8.00802 7.79157 8.18746 7.53575 8.29343C7.27994 8.39939 6.99844 8.42711 6.72687 8.37309C6.4553 8.31908 6.20584 8.18574 6.01005 7.98994C5.81425 7.79415 5.68091 7.54469 5.6269 7.27312C5.57288 7.00155 5.6006 6.72006 5.70656 6.46424C5.81253 6.20842 5.99197 5.98977 6.2222 5.83594Z" fill="currentColor"></path>
                        </svg>
                    </slot>
                    <slot name="password-show" v-else>
                        <!-- <svg
                            class="input-password__toggle-icon input-password__toggle-icon--show"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20">
                            <path d="M.2 10a11 11 0 0 1 19.6 0A11 11 0 0 1 .2 10zm9.8 4a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/>
                        </svg> -->
                        <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="input-password__toggle-icon input-password__toggle-icon--show" aria-hidden="true" data-pc-section="maskicon">
                            <title> {{ toggleMessage }} </title>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9414 6.74792C13.9437 6.75295 13.9455 6.757 13.9469 6.76003C13.982 6.8394 14.0001 6.9252 14.0001 7.01195C14.0001 7.0987 13.982 7.1845 13.9469 7.26386C13.6004 8.00059 13.1711 8.69549 12.6674 9.33515C12.6115 9.4071 12.54 9.46538 12.4582 9.50556C12.3765 9.54574 12.2866 9.56678 12.1955 9.56707C12.0834 9.56671 11.9737 9.53496 11.8788 9.47541C11.7838 9.41586 11.7074 9.3309 11.6583 9.23015C11.6092 9.12941 11.5893 9.01691 11.6008 8.90543C11.6124 8.79394 11.6549 8.68793 11.7237 8.5994C12.1065 8.09726 12.4437 7.56199 12.7313 6.99995C12.2595 6.08027 10.3402 2.8014 6.99732 2.8014C6.63723 2.80218 6.27816 2.83969 5.92569 2.91336C5.77666 2.93304 5.62568 2.89606 5.50263 2.80972C5.37958 2.72337 5.29344 2.59398 5.26125 2.44714C5.22907 2.30031 5.2532 2.14674 5.32885 2.01685C5.40451 1.88696 5.52618 1.79021 5.66978 1.74576C6.10574 1.64961 6.55089 1.60134 6.99732 1.60181C11.5916 1.60181 13.7864 6.40856 13.9414 6.74792ZM2.20333 1.61685C2.35871 1.61411 2.5091 1.67179 2.6228 1.77774L12.2195 11.3744C12.3318 11.4869 12.3949 11.6393 12.3949 11.7983C12.3949 11.9572 12.3318 12.1097 12.2195 12.2221C12.107 12.3345 11.9546 12.3976 11.7956 12.3976C11.6367 12.3976 11.4842 12.3345 11.3718 12.2221L10.5081 11.3584C9.46549 12.0426 8.24432 12.4042 6.99729 12.3981C2.403 12.3981 0.208197 7.59135 0.0532336 7.25198C0.0509364 7.24694 0.0490875 7.2429 0.0476856 7.23986C0.0162332 7.16518 3.05176e-05 7.08497 3.05176e-05 7.00394C3.05176e-05 6.92291 0.0162332 6.8427 0.0476856 6.76802C0.631261 5.47831 1.46902 4.31959 2.51084 3.36119L1.77509 2.62545C1.66914 2.51175 1.61146 2.36136 1.61421 2.20597C1.61695 2.05059 1.6799 1.90233 1.78979 1.79244C1.89968 1.68254 2.04794 1.6196 2.20333 1.61685ZM7.45314 8.35147L5.68574 6.57609V6.5361C5.5872 6.78938 5.56498 7.06597 5.62183 7.33173C5.67868 7.59749 5.8121 7.84078 6.00563 8.03158C6.19567 8.21043 6.43052 8.33458 6.68533 8.39089C6.94014 8.44721 7.20543 8.43359 7.45314 8.35147ZM1.26327 6.99994C1.7351 7.91163 3.64645 11.1985 6.99729 11.1985C7.9267 11.2048 8.8408 10.9618 9.64438 10.4947L8.35682 9.20718C7.86027 9.51441 7.27449 9.64491 6.69448 9.57752C6.11446 9.51014 5.57421 9.24881 5.16131 8.83592C4.74842 8.42303 4.4871 7.88277 4.41971 7.30276C4.35232 6.72274 4.48282 6.13697 4.79005 5.64041L3.35855 4.2089C2.4954 5.00336 1.78523 5.94935 1.26327 6.99994Z" fill="currentColor"></path>
                        </svg>
                    </slot>
                </button>
            </slot>
        </div>

        <slot
            v-if="!disableStrengthMeter"
            name="strength-meter"
            :strength="passwordStrength"
        >
            <!-- <div class="input-password__meter" :title="strengthMessage">
                <svg
                    v-for="i in 4"
                    :key="i"
                    :class="i <= strength ? strengthClass : ''"
                    preserveAspectRatio="none"
                    :data-strength="i"
                    viewBox="0 0 2 1">
                    <rect width="100%" height="100%"></rect>
                </svg>
            </div> -->
            <div v-if="showStrengthMeter" class="d-flex flex-nowrap">
                <div :class="[strengthMeterClass, 'flex-grow-1']">
                    <div :class="[strengthMeterFillClass]" :data-score="passwordStrength"></div>
                </div>
                <div
                    class="d-print-none d-sm-flex text-muted flex-nowrap input-password__strength-meter--help">
                    <i :class="['fas fa-info-circle']"
                        data-custom-class="tooltip-password-meter"
                        data-toggle="tooltip-city"
                        data-placement="left"
                        data-html="true"
                        :title="helpMeter">
                    </i>
                </div>
            </div>
        </slot>

        <template v-if="!strengthMeterOnly">
            <small v-if="error" class="invalid-feedback">{{ error }}</small>
            <HelpSpan :helpText="helpText" :truncateText="helpTruncate" />
        </template>
    </div>
</template>

<script>
import { checkStrength, scorePassword } from '@/libraries//password-meter/logic'

export default {
    name: 'MaterialPassword',
    inheritAttrs: false,
    components: {
        HelpSpan: () => import(/* webpackChunkName: "help-span" */ '@/components/form/HelpSpan.vue'),
    },
    props: {
        id: {
            type: String,
        },
        name: {
            type: String,
            default: null
        },
        // type: {
        //     type: String,
        //     default: 'password'
        // },
        value: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        title: {
            type: String,
            default: null
        },
        classes: {
            type: [Object, Array, String]
        },
        invalidClasses: {
            type: [Array, Object, String],
        },
        inputClasses: {
            type: [Array, Object, String],
        },
        errorMessages: {
            type: [Array, String],
            default: null
        },
        error: {
            type: String,
            default: null
        },
        required: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: String,
            default: 'off',
        },
        readonly: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        helpText: {
            type: String,
            default: null
        },
        helpTruncate: {
            type: Boolean,
            default: true
        },
        labelClass: {
            type: Object,
            default: ()=> {return {}},
        },
        minimumStrength: {
            type: Number,
            default: 0
        },
        /**
         * Prop to disable the
         * strength Meter
         */
         disableStrengthMeter: {
            type: Boolean,
            default: false
        },
        /**
         * Prop to toggle the
         * strength Meter if
         * User wants to implement
         * their own
         */
        showStrengthMeter: {
            type: Boolean,
            default: true
        },
        /**
         * Prop to toggle the
         * input element if
         * User wants to implement
         * their own input element
         */
        strengthMeterOnly: {
            type: Boolean,
            default: false
        },
        /**
         * Show password toggle:
         * Show icon to toggle
         * the password visibility
         */
        showToggle: {
            type: Boolean,
            default: true
        },
        /**
         * Password min length.
         * Right now only visual for the badge
         * @type {Number}
         */
        secureLength: {
            type: Number,
            default: 8
        },
        /**
         * CSS class for styling the
         * strength meter bars.
         * @type {String}
         */
        strengthMeterClass: {
            type: String,
            default: 'input-password__strength-meter'
        },
        /**
         * strengthMeterFillClass sets the
         * individual strength width and fill
         * color of the strength meter bars.
         * @type {String}
         */
        strengthMeterFillClass: {
            type: String,
            default: 'input-password__strength-meter--fill'
        },
        /**
         * Label for the show password icon
         */
        labelShow: {
            type: String,
            default: 'Show Password'
        },
        /**
         * Label for the hide password icon
         */
        labelHide: {
            type: String,
            default: 'Hide Password'
        },
    },
    data () {
        return {
            type: this.$attrs.type,
            password: this.value,
            focus: false,
            valid: true,
        }
    },
    mounted() {
        if (!this.$attrs.type) {
            this.togglePassword(false);
        }
    },
    computed: {
        inputElement () {
            if (this.$refs.input) {
                return this.$refs.input;
            }
            if (this.$el) {
                return this.$el.querySelector(".input-password__container input");
            }
            return null;
        },
        hasValue () {
            return this.password != undefined && this.password != null && (this.password + '').trim() !== '';
        },
        computedClasses () {
            return {
            'material--active': this.focus,
            'material--disabled': this.disabled,
            'material--has-errors': Boolean(
                !this.valid ||
                (this.errorMessages && this.errorMessages.length)),
            'material--raised': Boolean(
                this.focus ||
                this.hasValue || // has value
                (this.placeholder && !this.hasValue)) // has placeholder
            }
        },
        activeClass () {
            return {
            'active': Boolean(
                this.focus ||
                this.hasValue || // has value
                (this.placeholder && !this.hasValue)) // has placeholder
            }
        },
        /**
         * passwordStrength is the score calculated by zxcvbn
         * @return {Number} Password Strength Score
         */
        passwordStrength () {
            return !this.disableStrengthMeter && this.password ? scorePassword(this.password, this.secureLength) : null; // zxcvbn(this.password, (this.userInputs.length >= 1 ? this.userInputs : null)).score : null
        },
        hasMinimumStrength () {
            return this.minimumStrength > 0;
        },
        isStrong () {
            return (this.passwordStrength ?? 0) >= this.minimumStrength;
        },
         /**
         * passwordCount holds the character count of the
         * current password. It shows the count up to the `secureLength`.
         * @return {Number} Password Character Count
         */
        passwordCount () {
            return this.password && (this.password.length > this.secureLength ? `${this.secureLength}+` : this.password.length)
        },
        /**
         * isSecure checks if the length of the password is longer then
         * the defined `secureLength`
         * @return {Boolean} Password length longer then minLength
         */
        isSecure () {
            return this.password ? this.password.length >= this.secureLength : null
        },
        /**
         * isActive checks if a password is entered.
         * It's required for the password count badge.
         * @return {Boolean} Password entered
         */
        isActive () {
            return !this.disableStrengthMeter && this.password && this.password.length > 0;
        },
        toggleMessage() {
            return this.type === "password" ? this.labelShow : this.labelHide;
        },
        helpMeter () {
            let total = this.secureLength;
            let least = 1;
            // return '<p>' + this.$t('global.password.meter.help.description', {total, least}) + '</p>\
            //         <ul>\
            //             <li class="info-useLowercase"><span></span>' + this.$t('global.password.meter.help.lowercase', {least}) + '</li>\
            //             <li class="info-useUppercase"><span></span>' + this.$t('global.password.meter.help.uppercase', {least}) + '</li>\
            //             <li class="info-useNumbers"><span></span>' + this.$t('global.password.meter.help.numbers', {least}) + '</li>\
            //             <li class="info-useSpecial"><span></span>' + this.$t('global.password.meter.help.special', {least}) + '</li>\
            //             <li class="info-numcharacters"><span></span>' + this.$t('global.password.meter.help.numcharacters', {total}) + '</li>\
            //         </ul>';
            return '<ul class="font-family-normal">\
                        <li class="info-numcharacters">' + this.$t('global.password.meter.help.numcharacters', {total}) + '</li>\
                        <li class="info-useLowercase">' + this.$t('global.password.meter.help.lowercase', {least}) + '</li>\
                        <li class="info-useUppercase">' + this.$t('global.password.meter.help.uppercase', {least}) + '</li>\
                        <li class="info-useNumbers">' + this.$t('global.password.meter.help.numbers', {least}) + '</li>\
                        <li class="info-useSpecial">' + this.$t('global.password.meter.help.special', {least}) + '</li>\
                    </ul>';
        },
    },
    methods: {
        handleFocus(type, value, focused, event) {
            if(!(this.disabled || this.readonly)){
                this.focus = focused
                this.emitValue(type, value, event);
            }
        },
        onKeyDown(event) {
            this.$emit('keyDown', event)
        },
        onKeyUp(event) {
            this.$emit('keyUp', event)
        },
        onKeyEnter(event) {
            this.$emit('keyEnter', event)
        },
        /**
         * Toggle the visibilty of the password.
         */
        togglePassword(focus = true) {
            this.type = this.type === "password" ? "text" : "password";
            this.inputElement.setAttribute("type", this.type);
            this.$emit(this.type === "password" ? 'hide' : 'show');

            if (focus) {
                this.inputElement.focus();
            }
        },
        emitValue(type, value, event) {
            // if(!this.hasMinimumStrength
            //     || this.hasMinimumStrength && type != 'input'
            //     || this.isStrong && type == 'input'
            // ) {
            //     this.$emit(type, value, event);
            // }
            this.$emit(type, value, event);
            this.password = value
        },
    },
    watch: {
        value (newValue) {
            // if (this.strengthMeterOnly) {
            //     this.emitValue('input', newValue)
            // }
            this.emitValue('input', newValue)
            // this.$emit('feedback', 0) //zxcvbn(newValue).feedback
        },
        // isStrong (value) {
        //     this.$emit('input', value ? this.password : null)
        // },
        passwordStrength (score) {
            this.$emit('score', score)
        },
    },
}
</script>

<style scoped lang="scss">
.input-password {

    & &__container {
        align-items: center;
        display: flex;
        text-align: center;
        position: relative;
    }

    & &__input {
        background-image: none; /* to remove cross/invalid image */
    }

    & &__input--has-toggle {
        padding-right: 3rem;
    }

    & &__toggle {
        align-items: center;
        background: none;
        border: none;
        bottom: 0;
        color: #94a3b8;
        display: flex;
        margin-right: 0.75rem;
        outline: none;
        position: absolute;
        right: 0;
        top: 0;
    }

    & &__toggle:hover {
        color: #4a5568;
        transition: color 0.3s ease-in-out;
    }

    & &__toggle-icon {
        fill: currentColor;
        pointer-events: none;
        width: 1rem;
    }

    /*& &__meter {
        color: rgb(175, 175, 175);
        display: flex;
        height: 0.25rem;
        margin-left: -0.25%;
        margin-right: -0.25%;
        margin-top: 0.4rem;
    }

    & &__meter svg {
        fill: currentColor;
        height: 100%;
        padding-left: 0.25%;
        padding-right: 0.25%;
        transition: all 0.6s ease-in-out;
        width: 25%;
    }*/

    & &__strength-meter {
        position: relative;
        height: 3px;
        background: #DDD;
        margin: 10px auto 10px;
        border-radius: 3px;
    }

    & &__strength-meter:before,
    & &__strength-meter:after {
        content: '';
        height: inherit;
        background: transparent;
        display: block;
        border-color: #FFF;
        border-style: solid;
        border-width: 0 5px 0 5px;
        position: absolute;
        width: 20%;
        z-index: 10;
    }

    & &__strength-meter:before {
        left: 20%;
    }

    & &__strength-meter:after {
        right: 20%;
    }

    & &__strength-meter--fill {
        background: transparent;
        height: inherit;
        position: absolute;
        width: 0;
        border-radius: inherit;
        transition: width 0.5s ease-in-out, background 0.25s;
    }

    & &__strength-meter--fill[data-score='0'] {
        background: darkred;
        width: 20%;
    }

    & &__strength-meter--fill[data-score='1'] {
        background: orangered;
        width: 40%;
    }

    & &__strength-meter--fill[data-score='2'] {
        background: orange;
        width: 60%;
    }

    & &__strength-meter--fill[data-score='3'] {
        background: yellowgreen;
        width: 80%;
    }

    & &__strength-meter--fill[data-score='4'] {
        background: green;
        width: 100%;
    }

    & &__strength-meter--help {
        i {
            font-size: .875rem;
            margin-top: 5px;
            margin-left: 5px;
        }
    }
}

/*
.po-password-strength-bar {
  border-radius: 2px;
  transition: all 0.2s linear;
  height: 5px;
  margin-top: 8px;
}

.po-password-strength-bar.risky {
  background-color: #f95e68;
  width: 10%;
}

.po-password-strength-bar.guessable {
  background-color: #fb964d;
  width: 32.5%;
}

.po-password-strength-bar.weak {
  background-color: #fdd244;
  width: 55%;
}

.po-password-strength-bar.safe {
  background-color: #b0dc53;
  width: 77.5%;
}

.po-password-strength-bar.secure {
  background-color: #35cc62;
  width: 100%;
}
*/

</style>

<style lang="scss">
.tooltip-password-meter {

    &.bs-tooltip-left .arrow::before {
        border-left-color: #e2e8f0;
        border-width: 0.6rem 0 0.6rem 0.6rem;
    }
    &.bs-tooltip-top .arrow::before {
        border-top-color: #e2e8f0;
        border-width: 0.6rem 0.6rem 0;
    }
    &.bs-tooltip-right .arrow::before {
        border-right-color: #e2e8f0;
    }
    &.bs-tooltip-bottom .arrow::before {
        border-bottom-color: #e2e8f0;
        border-width: 0 0.6rem 0.6rem;
    }

    .tooltip-inner {
        text-align: left;
        max-width: 300px;
        padding: .75rem;
        background: #ffffff;
        color: #6c757d;
        border: 1px solid #e2e8f0;
        box-shadow: 0px 4px 6px -1px rgba(0,0,0,0.1),0px 2px 4px -2px rgba(0,0,0,0.1);

        ul {
            margin-bottom: 0;
            padding-left: .5rem;
            margin-left: .5rem;
            margin-top: 0;
            line-height: 1.5;
        }


        /*
        p {
            padding: 10px;
            margin-bottom: 0;
            background-color: $primary-color;
            color: #f1f1f1;
        }

        ul {
            padding: 7px;
            margin-bottom: 0;
            background-color: #f1f1f1;

            li {
                list-style: none;
                padding: 5px;
                display: flex;
                justify-content: left;
                align-items: center;

                span {
                    width: 15px;
                    height: 15px;
                    display: block;
                    float: left;
                    border-radius: 100%;
                    margin-right: 12px;
                    background-color: #f1f1f1;
                    border: 3px solid $primary-color;

                    &.pr-ok {
                        background-color: $primary-color;
                        border: 3px solid $primary-color;
                    }
                }
            }
        }
        */
    }
}
</style>